module.exports = __webpack_public_path__ + "static/img/bcg.09c22ad6.jpg";